















































import UserList from '@/views/Admin/User/UserList.vue';
import ProfilePanel from '@/views/Tab/ProfilePanel.vue';
import RolesPanel from '@/views/Tab/RolesPanel.vue';
import ShipPanel from '@/views/Tab/ShipPanel.vue';
import ClassList from '@/views/Admin/Class/ClassList.vue';
import TabCard from '@/components/Tabs.vue';
import {Vue, Component} from 'vue-property-decorator';
import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';
@Component({
  computed: {...mapGetters(['currentTab'])},
  methods: {...mapActions(['setCurrentTab'])},
  components: {
    UserList,
    ProfilePanel,
    RolesPanel,
    ShipPanel,
    ClassList,
    TabCard,
  },
})
export default class AdminPanel extends Vue {
  setCurrentTab: any;
  initialTab: String = this.$store.getters.currentTab.parent || 'userlist';
  tabs: Array<String> = ['userlist', 'profile', 'roles', 'ships', 'class'];

  changeTab(activeTab) {
    this.setCurrentTab({parent: activeTab, child: null});
  }
}
